import { useState } from 'react'
import { LogOut, X, LogIn } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useOktaAuth } from '@okta/okta-react'
import { useUser } from '../Context/UserContext'

const Header = ({ appName = 'S3 Storage Browser' }) => {
  const [showConfirm, setShowConfirm] = useState(false)
  const navigate = useNavigate()
  const { oktaAuth } = useOktaAuth()
  const userInfo = useUser()
  const user = userInfo || null

  const handleConfirm = () => {
    setShowConfirm(false)
    onSignOut()
  }

  const onSignOut = async () => {
    setShowConfirm(false)
    try {
      await oktaAuth.signOut()
      navigate('/')
    } catch (error) {
      console.error('Sign out error:', error)
    }
  }

  const onSignIn = async () => {
    try {
      await oktaAuth.signInWithRedirect()
    } catch (error) {
      console.error('Login error:', error)
      navigate('/no-access?reason=login-failed')
    }
  }

  return (
    <>
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between py-4 sm:h-16">
            {/* App Name / Logo */}
            <h1
              className="text-lg sm:text-xl font-semibold text-gray-800
                         cursor-pointer hover:text-[#7C3AED] transition-colors"
              onClick={() => {
                navigate('/')
                window.location.reload()
              }}
            >
              {appName}
            </h1>

            {/* Right Actions */}
            <div className="flex items-center space-x-4 mt-4 sm:mt-0">
              {user ? (
                <>
                  <span className="hidden sm:inline text-sm text-gray-600">
                    Hello, {user?.name || 'User'}
                  </span>

                  <button
                    onClick={() => setShowConfirm(true)}
                    className="flex items-center space-x-2 px-4 py-1.5 text-sm font-medium text-white bg-[#7C3AED] hover:bg-[#6D28D9] rounded-md transition focus:outline-none focus:ring-2 focus:ring-[#DDD6FE]"
                  >
                    <LogOut className="w-4 h-4" />
                    <span>Sign Out</span>
                  </button>
                </>
              ) : (
                <button
                  onClick={onSignIn}
                  className="flex items-center space-x-2 px-4 py-1.5 text-sm font-medium text-white bg-[#7C3AED] hover:bg-[#6D28D9] rounded-md transition focus:outline-none focus:ring-2 focus:ring-[#DDD6FE]"
                >
                  <LogIn className="w-4 h-4" />
                  <span>Sign In</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Sign Out Confirmation Modal */}
      {showConfirm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                Confirm Sign Out
              </h2>
              <button
                onClick={() => setShowConfirm(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <p className="text-sm text-gray-600 mb-6">
              Are you sure you want to sign out?
            </p>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className="px-4 py-2 text-sm text-white bg-[#7C3AED] hover:bg-[#6D28D9] rounded-md transition focus:outline-none focus:ring-2 focus:ring-[#DDD6FE]"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Header
